import { Check } from "lucide-react";
import { STATUSES, fmtDate } from "@/lib/api";

export function StatusTimeline({ order }) {
  const current = STATUSES.indexOf(order.status);
  const dates = Object.fromEntries((order.status_history || []).map((h) => [h.status, h.at]));
  return (
    <ol className="grid grid-cols-1 gap-3 sm:grid-cols-5 sm:gap-0" data-testid="status-timeline">
      {STATUSES.map((s, i) => {
        const done = i <= current;
        return (
          <li key={s} className="relative flex items-center gap-3 sm:flex-col sm:items-start sm:gap-2" data-testid={`timeline-step-${i}`}>
            <div className="flex w-full items-center">
              <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-full border-2 text-xs font-bold transition-colors ${done ? "border-[#0099DD] bg-[#0099DD] text-white" : "border-slate-300 bg-white text-slate-400"} ${i === current ? "ring-4 ring-sky-100" : ""}`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </span>
              {i < STATUSES.length - 1 && <span className={`hidden h-0.5 flex-1 sm:block ${i < current ? "bg-[#0099DD]" : "bg-slate-200"}`} />}
            </div>
            <div className="sm:pr-2">
              <p className={`text-xs font-bold ${done ? "text-slate-900" : "text-slate-400"}`}>{s}</p>
              {dates[s] && <p className="text-[11px] text-slate-400">{fmtDate(dates[s])}</p>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
